import { Vlan } from './vlan';
import { Compania } from './compania';

export class CrearVlanParametros {
	compania: Compania;
	idCiudad: number;
	idSede: number;
	idMascara: number;
	idAmbiente: number;
	nombreVlan: string;
	observaciones: string;
	ipInicial: string;
	vlanCreada: Vlan;
	conIps: Boolean;
	idSuperNet:number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/crear-vlan-parametros.ts